import { AnalyticsEventName } from './eventTypes';

export const ANALYTICS_EVENT_NAMES: Record<AnalyticsEventName, AnalyticsEventName> = {
  page_view: 'page_view',
  map_save: 'map_save',
  map_save_fail: 'map_save_fail',
  simulation_run_start: 'simulation_run_start',
  simulation_run_complete: 'simulation_run_complete',
  simulation_run_fail: 'simulation_run_fail',
  export_start: 'export_start',
  export_complete: 'export_complete',
  export_fail: 'export_fail',
  operations_co2_rate_updated: 'operations_co2_rate_updated',
  operations_co2_rate_invalid: 'operations_co2_rate_invalid',
  operations_view_render_fail: 'operations_view_render_fail',
  basemap_changed: 'basemap_changed',
  panel_toggled: 'panel_toggled',
  simulation_run_selected: 'simulation_run_selected',
  simulation_results_tab_changed: 'simulation_results_tab_changed',
  fixed_routes_tab_changed: 'fixed_routes_tab_changed',
  network_route_opened: 'network_route_opened',
  network_route_forked: 'network_route_forked',
  network_search: 'network_search',
  network_variant_toggled: 'network_variant_toggled',
  network_trips_viewed: 'network_trips_viewed',
  timetable_grid_mode_toggled: 'timetable_grid_mode_toggled',
  bods_gather_used: 'bods_gather_used',
  bods_network_export: 'bods_network_export',
  network_version_saved: 'network_version_saved',
  network_version_opened: 'network_version_opened',
  default_network_changed: 'default_network_changed',
  simulation_results_reloaded: 'simulation_results_reloaded',
  back_to_map_clicked: 'back_to_map_clicked',
  vehicle_search: 'vehicle_search',
  vehicle_visibility_changed: 'vehicle_visibility_changed',
  wizard_opened: 'wizard_opened',
  wizard_step_viewed: 'wizard_step_viewed',
  wizard_navigation_clicked: 'wizard_navigation_clicked',
  wizard_step_completed: 'wizard_step_completed',
  wizard_dismissed: 'wizard_dismissed',
  wizard_completed: 'wizard_completed',
  wizard_field_group_changed: 'wizard_field_group_changed',
  wizard_default_retained: 'wizard_default_retained',
  wizard_helper_start: 'wizard_helper_start',
  wizard_helper_complete: 'wizard_helper_complete',
  wizard_helper_fail: 'wizard_helper_fail',
  wizard_validation_blocked: 'wizard_validation_blocked',
  wizard_summary_edit_opened: 'wizard_summary_edit_opened',
  wizard_summary_edit_saved: 'wizard_summary_edit_saved',
  wizard_summary_edit_canceled: 'wizard_summary_edit_canceled',
  tool_directory_searched: 'tool_directory_searched',
  tool_directory_filtered: 'tool_directory_filtered',
  tool_share_opened: 'tool_share_opened',
  tool_share_link_copied: 'tool_share_link_copied',
  tool_share_opened_in_new_tab: 'tool_share_opened_in_new_tab',
  tool_launched: 'tool_launched',
  map_tool_activated: 'map_tool_activated',
  fleet_optimiser_field_group_changed: 'fleet_optimiser_field_group_changed',
  fleet_optimiser_capex_toggled: 'fleet_optimiser_capex_toggled',
  fleet_optimiser_analyze_clicked: 'fleet_optimiser_analyze_clicked',
  fleet_optimiser_result_displayed: 'fleet_optimiser_result_displayed',
  postcode_assignment_file_added: 'postcode_assignment_file_added',
  postcode_assignment_file_cleared: 'postcode_assignment_file_cleared',
  postcode_assignment_config_changed: 'postcode_assignment_config_changed',
  postcode_assignment_started: 'postcode_assignment_started',
  postcode_assignment_completed: 'postcode_assignment_completed',
  postcode_assignment_failed: 'postcode_assignment_failed',
  postcode_assignment_aborted: 'postcode_assignment_aborted',
  postcode_assignment_api_batch: 'postcode_assignment_api_batch',
  postcode_assignment_result_sheet_selected: 'postcode_assignment_result_sheet_selected',
  postcode_assignment_result_filtered: 'postcode_assignment_result_filtered',
  postcode_assignment_workbook_downloaded: 'postcode_assignment_workbook_downloaded',
  postcode_assignment_trips_pushed_to_map: 'postcode_assignment_trips_pushed_to_map',
  autopilot_dashboard_refreshed: 'autopilot_dashboard_refreshed',
  autopilot_jira_import_started: 'autopilot_jira_import_started',
  autopilot_jira_import_completed: 'autopilot_jira_import_completed',
  autopilot_jira_import_failed: 'autopilot_jira_import_failed',
  autopilot_dashboard_fetched: 'autopilot_dashboard_fetched',
  autopilot_item_opened: 'autopilot_item_opened',
  autopilot_item_tab_changed: 'autopilot_item_tab_changed',
  autopilot_artifact_viewed: 'autopilot_artifact_viewed',
  autopilot_external_link_opened: 'autopilot_external_link_opened',
  autopilot_item_status_updated: 'autopilot_item_status_updated',
  simulation_results_path_mode_changed: 'simulation_results_path_mode_changed',
  simulation_results_vehicle_row_selected: 'simulation_results_vehicle_row_selected',
  simulation_results_vehicle_visibility_toggled: 'simulation_results_vehicle_visibility_toggled',
  simulation_results_unallocated_visibility_changed: 'simulation_results_unallocated_visibility_changed',
  simulation_results_timeline_window_changed: 'simulation_results_timeline_window_changed',
  simulation_results_stop_clicked: 'simulation_results_stop_clicked',
  simulation_results_modal_opened: 'simulation_results_modal_opened',
  simulation_results_import_fixed_routes_started: 'simulation_results_import_fixed_routes_started',
  simulation_results_import_fixed_routes_succeeded: 'simulation_results_import_fixed_routes_succeeded',
  simulation_results_import_fixed_routes_failed: 'simulation_results_import_fixed_routes_failed',
  admin_analytics_view_changed: 'admin_analytics_view_changed',
  admin_analytics_filter_applied: 'admin_analytics_filter_applied',
  admin_analytics_inspector_opened: 'admin_analytics_inspector_opened',
  admin_analytics_chart_drilled: 'admin_analytics_chart_drilled',
  admin_analytics_export_clicked: 'admin_analytics_export_clicked',
  admin_analytics_saved_view_applied: 'admin_analytics_saved_view_applied',
  admin_analytics_share_link_copied: 'admin_analytics_share_link_copied',
  admin_analytics_realtime_paused: 'admin_analytics_realtime_paused',
  admin_analytics_cleanup_previewed: 'admin_analytics_cleanup_previewed',
  admin_analytics_cleanup_executed: 'admin_analytics_cleanup_executed',
  route_stops_add_started: 'route_stops_add_started',
  route_stops_add_completed: 'route_stops_add_completed',
  route_stops_update_completed: 'route_stops_update_completed',
  route_stops_delete_completed: 'route_stops_delete_completed',
  route_stops_reorder_completed: 'route_stops_reorder_completed',
  fixed_route_vehicle_mapping_saved: 'fixed_route_vehicle_mapping_saved',
  fixed_route_operations_plan_saved: 'fixed_route_operations_plan_saved',
  fixed_route_attach_operations_opened: 'fixed_route_attach_operations_opened',
  fixed_route_shifts_deployed: 'fixed_route_shifts_deployed',
  fixed_route_overlap_run_started: 'fixed_route_overlap_run_started',
  fixed_route_overlap_run_completed: 'fixed_route_overlap_run_completed',
  fixed_route_overlap_run_cancelled: 'fixed_route_overlap_run_cancelled',
  fixed_route_overlap_run_failed: 'fixed_route_overlap_run_failed',
  fixed_route_overlap_result_focused: 'fixed_route_overlap_result_focused',
  spatial_analysis_run_started: 'spatial_analysis_run_started',
  spatial_analysis_run_completed: 'spatial_analysis_run_completed',
  spatial_analysis_run_cancelled: 'spatial_analysis_run_cancelled',
  spatial_analysis_run_failed: 'spatial_analysis_run_failed',
  spatial_analysis_report_expanded: 'spatial_analysis_report_expanded',
  language_changed: 'language_changed',
};

export interface EventTaxonomyEntry {
  trigger: string;
  requiredParams: readonly string[];
  optionalParams: readonly string[];
}

export const EVENT_TAXONOMY: Record<AnalyticsEventName, EventTaxonomyEntry> = {
  page_view: {
    trigger: 'Initial app load and every SPA route transition',
    requiredParams: ['page_path', 'timestamp'],
    optionalParams: ['page_title'],
  },
  map_save: {
    trigger: 'Map save succeeds',
    requiredParams: ['map_id', 'layer_count', 'is_update', 'timestamp'],
    optionalParams: ['duration_ms'],
  },
  map_save_fail: {
    trigger: 'Map save fails',
    requiredParams: ['feature_area', 'error_category', 'layer_count', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'map_id', 'duration_ms'],
  },
  simulation_run_start: {
    trigger: 'Simulation run starts',
    requiredParams: ['rides_count', 'fleet_size', 'frodo_enabled', 'timestamp'],
    optionalParams: [],
  },
  simulation_run_complete: {
    trigger: 'Simulation run completes successfully',
    requiredParams: ['run_id', 'rides_count', 'fleet_size', 'timestamp'],
    optionalParams: ['success_ratio', 'duration_ms'],
  },
  simulation_run_fail: {
    trigger: 'Simulation run fails',
    requiredParams: ['feature_area', 'error_category', 'rides_count', 'fleet_size', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'duration_ms'],
  },
  export_start: {
    trigger: 'Export action starts',
    requiredParams: ['export_type', 'export_source', 'timestamp'],
    optionalParams: ['item_count'],
  },
  export_complete: {
    trigger: 'Export action completes',
    requiredParams: ['export_type', 'export_source', 'timestamp'],
    optionalParams: ['item_count', 'duration_ms'],
  },
  export_fail: {
    trigger: 'Export action fails',
    requiredParams: ['feature_area', 'error_category', 'export_type', 'export_source', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'item_count', 'duration_ms'],
  },
  operations_co2_rate_updated: {
    trigger: 'CO2 rate input changes in operations view',
    requiredParams: ['rate_kg_per_km', 'source', 'timestamp'],
    optionalParams: [],
  },
  operations_co2_rate_invalid: {
    trigger: 'Invalid CO2 rate is provided and fallback value is applied',
    requiredParams: ['input_value', 'fallback_value', 'timestamp'],
    optionalParams: [],
  },
  operations_view_render_fail: {
    trigger: 'Operations view rendering fails during client-side calculations',
    requiredParams: ['feature_area', 'error_category', 'timestamp'],
    optionalParams: ['error_code', 'retryable'],
  },
  basemap_changed: {
    trigger: 'User selects a different basemap style',
    requiredParams: ['new_basemap', 'previous_basemap', 'timestamp'],
    optionalParams: [],
  },
  panel_toggled: {
    trigger: 'User opens or closes a sidebar panel on the Map screen',
    requiredParams: ['panel_name', 'is_open', 'screen_area', 'timestamp'],
    optionalParams: [],
  },
  simulation_run_selected: {
    trigger: 'User selects a simulation run from the dropdown in Simulation Results',
    requiredParams: ['run_id', 'available_runs_count', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_tab_changed: {
    trigger: 'User switches between Operations, Timeline, or Unmatched tabs',
    requiredParams: ['tab_name', 'timestamp'],
    optionalParams: ['previous_tab'],
  },
  fixed_routes_tab_changed: {
    trigger: 'User switches between tabs in the Fixed Routes drawer (Routes / Stops / Timetable / Statistics / FRODO / Data / Network)',
    requiredParams: ['tab_name', 'timestamp'],
    optionalParams: ['previous_tab'],
  },
  network_route_opened: {
    trigger: 'User opens a hosted-network route in the Fixed Routes drawer Network tab to preview its stops',
    requiredParams: ['feed_id', 'route_id', 'timestamp'],
    optionalParams: [],
  },
  network_route_forked: {
    trigger: 'User forks a live hosted-network route into an editable copy (PRD-04 FR15/FR16)',
    requiredParams: ['feed_id', 'gtfs_route_id', 'fixed_route_id', 'stop_count', 'timestamp'],
    optionalParams: [],
  },
  network_search: {
    trigger: 'User searches a hosted network for routes/stops from the Transit Networks panel',
    requiredParams: ['feed_id', 'query_length', 'route_results', 'stop_results', 'timestamp'],
    optionalParams: [],
  },
  network_variant_toggled: {
    trigger: "User switches a selected network route's direction/shape variant (PRD-04 FR6a)",
    requiredParams: ['feed_id', 'route_id', 'direction', 'has_shape', 'timestamp'],
    optionalParams: [],
  },
  network_trips_viewed: {
    trigger: "User views a hosted route's trips for a chosen day-of-week + direction (PRD-05)",
    requiredParams: ['feed_id', 'route_id', 'day', 'direction', 'trip_count', 'timestamp'],
    optionalParams: [],
  },
  timetable_grid_mode_toggled: {
    trigger: "User toggles the bustimes-style timetable grid between Timing points and All stops",
    requiredParams: ['surface', 'mode', 'timestamp'],
    optionalParams: ['feed_id', 'route_id'],
  },
  bods_gather_used: {
    trigger: 'A Spatial Analysis run completes using UK BODS (Bus Open Data) as the transit source (PRD-01)',
    requiredParams: ['run_id', 'source', 'timestamp'],
    optionalParams: ['stop_count'],
  },
  bods_network_export: {
    trigger: 'User exports an edited hosted network to a BODS TransXChange package (PRD-05b)',
    requiredParams: ['feed_id', 'scope', 'route_count', 'edited_count', 'timestamp'],
    optionalParams: ['new_count', 'stops_without_atco', 'duration_ms'],
  },
  network_version_saved: {
    trigger: 'User saves their edits as a reusable version of a hosted network (PRD-05c)',
    requiredParams: ['feed_id', 'edited_count', 'new_count', 'timestamp'],
    optionalParams: [],
  },
  network_version_opened: {
    trigger: 'User opens a saved network version back into the Fixed Routes editor (PRD-05c)',
    requiredParams: ['feed_id', 'edited_count', 'new_count', 'timestamp'],
    optionalParams: [],
  },
  default_network_changed: {
    trigger: 'User or company admin sets/clears a default transit network (cascades to sign-in)',
    requiredParams: ['scope', 'feed_id', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_reloaded: {
    trigger: 'User clicks the reload button on the Simulation Results sidebar',
    requiredParams: ['timestamp'],
    optionalParams: ['run_id'],
  },
  back_to_map_clicked: {
    trigger: 'User clicks Back to Map from the Simulation Results screen',
    requiredParams: ['from_screen', 'timestamp'],
    optionalParams: [],
  },
  vehicle_search: {
    trigger: 'User types in the vehicle search field in the Operations view',
    requiredParams: ['query_length', 'result_count', 'timestamp'],
    optionalParams: [],
  },
  vehicle_visibility_changed: {
    trigger: 'User shows or hides vehicles in the Operations view',
    requiredParams: ['action', 'vehicle_count', 'timestamp'],
    optionalParams: [],
  },
  wizard_opened: {
    trigger: 'Onboarding / quick-start wizard becomes visible on the Map screen',
    requiredParams: ['wizard_session_id', 'entrypoint', 'wizard_version', 'timestamp'],
    optionalParams: ['step_id', 'step_index'],
  },
  wizard_step_viewed: {
    trigger: 'User lands on a wizard step (once per step transition)',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'timestamp'],
    optionalParams: ['preset', 'service_mode'],
  },
  wizard_navigation_clicked: {
    trigger: 'User clicks Next, Back, or jumps from Summary to an earlier step',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'action', 'timestamp'],
    optionalParams: ['target_step_id', 'target_step_index'],
  },
  wizard_step_completed: {
    trigger: 'User completes a wizard step via valid forward navigation',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'step_duration_ms', 'timestamp'],
    optionalParams: ['used_helper'],
  },
  wizard_dismissed: {
    trigger: 'Wizard closes before successful Run Simulation',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'elapsed_session_ms', 'timestamp'],
    optionalParams: ['dismiss_source', 'step_duration_ms'],
  },
  wizard_completed: {
    trigger: 'Run Simulation succeeds from the wizard summary step',
    requiredParams: ['wizard_session_id', 'elapsed_session_ms', 'timestamp'],
    optionalParams: ['final_step_id', 'preset', 'service_mode', 'step_duration_ms'],
  },
  wizard_field_group_changed: {
    trigger: 'First meaningful deviation from defaults for a tracked field group',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'field_group', 'timestamp'],
    optionalParams: ['change_source'],
  },
  wizard_default_retained: {
    trigger: 'On dismiss or complete, a tracked field group was never changed from defaults',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'field_group', 'completion_status', 'timestamp'],
    optionalParams: [],
  },
  wizard_helper_start: {
    trigger: 'User starts a wizard-owned helper (demand insight, fleet generator, map draw)',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'helper_type', 'timestamp'],
    optionalParams: [],
  },
  wizard_helper_complete: {
    trigger: 'Wizard-owned helper completes successfully with usable output',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'helper_type', 'timestamp'],
    optionalParams: ['became_authoritative', 'authoritative_ride_layer_set', 'authoritative_fleet_set'],
  },
  wizard_helper_fail: {
    trigger: 'Wizard-owned helper fails',
    requiredParams: [
      'wizard_session_id',
      'step_id',
      'step_index',
      'helper_type',
      'feature_area',
      'error_category',
      'timestamp',
    ],
    optionalParams: ['error_code', 'retryable'],
  },
  wizard_validation_blocked: {
    trigger: 'User attempts Next or Run while the current step is invalid',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'validation_reason', 'timestamp'],
    optionalParams: [],
  },
  wizard_summary_edit_opened: {
    trigger: 'User opens a summary-only inline editor',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'field', 'timestamp'],
    optionalParams: [],
  },
  wizard_summary_edit_saved: {
    trigger: 'User saves a summary-only inline editor',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'field', 'timestamp'],
    optionalParams: [],
  },
  wizard_summary_edit_canceled: {
    trigger: 'User cancels a summary-only inline editor',
    requiredParams: ['wizard_session_id', 'step_id', 'step_index', 'field', 'timestamp'],
    optionalParams: [],
  },
  tool_directory_searched: {
    trigger: 'User types in the search field on the Tools directory',
    requiredParams: ['query_length', 'result_count', 'timestamp'],
    optionalParams: [],
  },
  tool_directory_filtered: {
    trigger: 'User changes the category filter on the Tools directory',
    requiredParams: ['category', 'result_count', 'timestamp'],
    optionalParams: [],
  },
  tool_share_opened: {
    trigger: 'User opens the share dialog for a tool card',
    requiredParams: ['tool_id', 'timestamp'],
    optionalParams: [],
  },
  tool_share_link_copied: {
    trigger: 'User copies the share link in the share dialog',
    requiredParams: ['tool_id', 'fallback_used', 'succeeded', 'timestamp'],
    optionalParams: [],
  },
  tool_share_opened_in_new_tab: {
    trigger: 'User opens the share link in a new tab from the share dialog',
    requiredParams: ['tool_id', 'timestamp'],
    optionalParams: [],
  },
  tool_launched: {
    trigger: 'A tool page mounts (covers directory click and shared / direct link entry)',
    requiredParams: ['tool_id', 'source', 'timestamp'],
    optionalParams: [],
  },
  map_tool_activated: {
    trigger: 'User activates a tool from the on-map drawing toolbar (click or keyboard)',
    requiredParams: ['tool_name', 'activation_source', 'is_active', 'timestamp'],
    optionalParams: [],
  },
  fleet_optimiser_field_group_changed: {
    trigger: 'First deviation from defaults for a tracked field group on the Fleet Optimiser',
    requiredParams: ['field_group', 'timestamp'],
    optionalParams: [],
  },
  fleet_optimiser_capex_toggled: {
    trigger: 'User toggles the capex section on the Fleet Optimiser',
    requiredParams: ['section', 'enabled', 'timestamp'],
    optionalParams: [],
  },
  fleet_optimiser_analyze_clicked: {
    trigger: 'User clicks Analyze Impact on the Fleet Optimiser',
    requiredParams: ['has_validation_errors', 'timestamp'],
    optionalParams: [],
  },
  fleet_optimiser_result_displayed: {
    trigger: 'Fleet Optimiser result panel renders after a valid analyze',
    requiredParams: ['analysis_years', 'has_capex', 'savings_bucket', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_file_added: {
    trigger: 'User selects or drops a file on the Postcode Stop Assignment tool',
    requiredParams: ['file_type', 'upload_method', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_file_cleared: {
    trigger: 'User clears a previously selected file on the Postcode Stop Assignment tool',
    requiredParams: ['file_type', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_config_changed: {
    trigger: 'User changes a configuration field group on the Postcode Stop Assignment tool',
    requiredParams: ['field_group', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_started: {
    trigger: 'User starts the postcode assignment run',
    requiredParams: [
      'postcode_rows',
      'sheet_count',
      'has_hub_file',
      'osm_search_radius_m',
      'use_osrm_walking_for_consolidation',
      'timestamp',
    ],
    optionalParams: [],
  },
  postcode_assignment_completed: {
    trigger: 'Postcode assignment run completes successfully',
    requiredParams: [
      'postcode_rows',
      'geocoded_rows',
      'stops_assigned',
      'hubs_assigned',
      'walking_distance_rows',
      'duration_ms',
      'timestamp',
    ],
    optionalParams: [],
  },
  postcode_assignment_failed: {
    trigger: 'Postcode assignment run fails',
    requiredParams: ['feature_area', 'error_category', 'failed_stage', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'duration_ms'],
  },
  postcode_assignment_aborted: {
    trigger: 'User aborts an in-flight postcode assignment run',
    requiredParams: ['timestamp'],
    optionalParams: [],
  },
  postcode_assignment_api_batch: {
    trigger: 'A postcode assignment sub-API batch transitions state (start / succeed / fail)',
    requiredParams: ['provider', 'outcome', 'batch_index', 'items_in', 'timestamp'],
    optionalParams: ['items_out', 'duration_ms', 'error_category'],
  },
  postcode_assignment_result_sheet_selected: {
    trigger: 'User selects a result sheet on the Postcode Stop Assignment tool',
    requiredParams: ['sheet_index', 'row_count', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_result_filtered: {
    trigger: 'User filters the assignment results table',
    requiredParams: ['query_length', 'matched_rows', 'timestamp'],
    optionalParams: [],
  },
  postcode_assignment_workbook_downloaded: {
    trigger: 'User downloads a workbook from the Postcode Stop Assignment tool',
    requiredParams: ['sheet_count', 'total_rows', 'includes_walking_distances', 'timestamp'],
    optionalParams: ['output_kind'],
  },
  postcode_assignment_trips_pushed_to_map: {
    trigger: 'User pushes simulation trips from the Postcode Stop Assignment tool directly into the map layers',
    requiredParams: [
      'trip_count',
      'passenger_count',
      'consolidated_stop_count',
      'vehicle_count',
      'depot_source',
      'timestamp',
    ],
    optionalParams: [],
  },
  autopilot_dashboard_refreshed: {
    trigger: 'Autopilot dashboard refresh fires (button or initial mount)',
    requiredParams: ['trigger', 'timestamp'],
    optionalParams: [],
  },
  autopilot_jira_import_started: {
    trigger: 'User starts a Jira import on the Autopilot dashboard',
    requiredParams: ['timestamp'],
    optionalParams: [],
  },
  autopilot_jira_import_completed: {
    trigger: 'Jira import on Autopilot dashboard completes',
    requiredParams: ['imported', 'updated', 'skipped', 'total_processed', 'duration_ms', 'timestamp'],
    optionalParams: [],
  },
  autopilot_jira_import_failed: {
    trigger: 'Jira import on Autopilot dashboard fails',
    requiredParams: ['feature_area', 'error_category', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'duration_ms'],
  },
  autopilot_dashboard_fetched: {
    trigger: 'Autopilot dashboard fetches the queue',
    requiredParams: ['items_count', 'queue_mode', 'duration_ms', 'timestamp'],
    optionalParams: [],
  },
  autopilot_item_opened: {
    trigger: 'User opens an item details dialog on the Autopilot dashboard',
    requiredParams: ['item_id', 'item_status', 'wsjf', 'in_queue', 'timestamp'],
    optionalParams: [],
  },
  autopilot_item_tab_changed: {
    trigger: 'User switches tabs in an Autopilot item details dialog',
    requiredParams: ['item_id', 'tab_name', 'timestamp'],
    optionalParams: ['previous_tab'],
  },
  autopilot_artifact_viewed: {
    trigger: 'User views a PRD or Tasks artifact on the Autopilot dashboard',
    requiredParams: ['item_id', 'artifact_type', 'source', 'outcome', 'timestamp'],
    optionalParams: ['bytes_loaded'],
  },
  autopilot_external_link_opened: {
    trigger: 'User opens an external link from an Autopilot item',
    requiredParams: ['item_id', 'link_type', 'timestamp'],
    optionalParams: [],
  },
  autopilot_item_status_updated: {
    trigger: 'User triggers a status update on an Autopilot item',
    requiredParams: ['item_id', 'new_status', 'has_reason', 'outcome', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_path_mode_changed: {
    trigger: 'User toggles between Roads and O–D lines on the simulation results map',
    requiredParams: ['mode', 'timestamp'],
    optionalParams: ['previous_mode'],
  },
  simulation_results_vehicle_row_selected: {
    trigger: 'User selects a vehicle row in the simulation results manifest or Gantt',
    requiredParams: ['source', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_vehicle_visibility_toggled: {
    trigger: 'User toggles a single vehicle visibility eye in the operations view',
    requiredParams: ['is_visible', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_unallocated_visibility_changed: {
    trigger: 'User toggles unallocated rides visibility in the operations view',
    requiredParams: ['is_visible', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_timeline_window_changed: {
    trigger: 'User changes the timeline window length in the operations timeline',
    requiredParams: ['window_hours', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_stop_clicked: {
    trigger: 'User clicks a stop or hub marker on the simulation results map',
    requiredParams: ['object_type', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_modal_opened: {
    trigger: 'User opens a sub-modal from the simulation results page',
    requiredParams: ['modal', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_import_fixed_routes_started: {
    trigger: 'User starts importing simulation results as a fixed-route network',
    requiredParams: ['run_id', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_import_fixed_routes_succeeded: {
    trigger: 'Simulation fixed-route network import completes successfully',
    requiredParams: ['run_id', 'route_count', 'stop_count', 'warnings_count', 'duration_ms', 'timestamp'],
    optionalParams: [],
  },
  simulation_results_import_fixed_routes_failed: {
    trigger: 'Simulation fixed-route network import fails',
    requiredParams: ['run_id', 'duration_ms', 'timestamp'],
    optionalParams: ['error_code'],
  },
  admin_analytics_view_changed: {
    trigger: 'Admin selects a different section in the analytics dashboard left rail',
    requiredParams: ['view', 'timestamp'],
    optionalParams: ['previous_view'],
  },
  admin_analytics_filter_applied: {
    trigger: 'Admin changes a filter on the analytics dashboard (date range, event name, hide-legacy, etc.)',
    requiredParams: ['filter_dimension', 'active_view', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_inspector_opened: {
    trigger: 'Admin opens the inspector side-panel for an event, user, or customer',
    requiredParams: ['target_kind', 'source_view', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_chart_drilled: {
    trigger: 'Admin clicks a chart bar, slice, or point to drill into the Events Explorer',
    requiredParams: ['source_chart', 'dimension', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_export_clicked: {
    trigger: 'Admin starts a CSV export from the Events Explorer',
    requiredParams: ['format', 'filtered', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_saved_view_applied: {
    trigger: 'Admin applies a saved view from the Events Explorer dropdown',
    requiredParams: ['has_event_name_filter', 'has_category_filter', 'has_customer_filter', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_share_link_copied: {
    trigger: 'Admin copies the current Events Explorer filter URL via the Share button',
    requiredParams: ['active_view', 'param_count', 'has_event_name_filter', 'has_category_filter', 'has_customer_filter', 'has_date_range', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_realtime_paused: {
    trigger: 'Realtime polling pauses or resumes (manual or via tab visibility change)',
    requiredParams: ['paused', 'reason', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_cleanup_previewed: {
    trigger: 'Admin runs a retention dry-run preview before cleanup',
    requiredParams: ['retention_days', 'estimated_events', 'timestamp'],
    optionalParams: [],
  },
  admin_analytics_cleanup_executed: {
    trigger: 'Admin executes the retention cleanup after preview and confirmation',
    requiredParams: ['retention_days', 'events_deleted', 'timestamp'],
    optionalParams: [],
  },
  route_stops_add_started: {
    trigger: 'User initiates an add-stops batch against a route version (createroutestop)',
    requiredParams: ['environment', 'product_id', 'route_id', 'version_id', 'stop_count', 'timestamp'],
    optionalParams: ['network_id'],
  },
  route_stops_add_completed: {
    trigger: 'Add-stops batch finishes (every createroutestop call resolved)',
    requiredParams: ['environment', 'product_id', 'route_id', 'version_id', 'stop_count', 'success_count', 'failure_count', 'timestamp'],
    optionalParams: ['network_id'],
  },
  route_stops_update_completed: {
    trigger: 'Update-stops batch finishes (updateroutestop calls resolved)',
    requiredParams: ['environment', 'product_id', 'route_id', 'version_id', 'stop_count', 'success_count', 'failure_count', 'timestamp'],
    optionalParams: ['network_id'],
  },
  route_stops_delete_completed: {
    trigger: 'Delete-stops batch finishes (deleteroutestop calls resolved)',
    requiredParams: ['environment', 'product_id', 'route_id', 'version_id', 'stop_count', 'success_count', 'failure_count', 'timestamp'],
    optionalParams: ['network_id'],
  },
  route_stops_reorder_completed: {
    trigger: 'Reorder-stops call finishes (orderroutestops)',
    requiredParams: ['environment', 'product_id', 'route_id', 'version_id', 'stop_count', 'success_count', 'failure_count', 'timestamp'],
    optionalParams: ['network_id'],
  },
  fixed_route_vehicle_mapping_saved: {
    trigger: 'User saves an Atlas → Ops vehicle mapping in the fixed-route VehicleMappingPanel',
    requiredParams: [
      'environment',
      'network_id',
      'slot_count',
      'mapped_count',
      'unmapped_count',
      'auto_matched_count',
      'has_presets',
      'timestamp',
    ],
    optionalParams: [],
  },
  fixed_route_operations_plan_saved: {
    trigger: 'User saves a DRAFT operation/vehicle/day deployment plan in the Attach Vehicles & Operations modal (no write to Ops)',
    requiredParams: [
      'environment',
      'network_id',
      'route_id',
      'operation_solution_id',
      'vehicle_count',
      'shift_solution_preview_count',
      'has_route_version',
      'timestamp',
    ],
    optionalParams: [],
  },
  fixed_route_attach_operations_opened: {
    trigger: 'User opens the Attach Vehicles & Operations modal from the Data Transfer drawer → Routes tab',
    requiredParams: ['environment', 'network_id', 'route_count', 'seeded_auth', 'timestamp'],
    optionalParams: [],
  },
  fixed_route_shifts_deployed: {
    trigger: 'A route upload attempts dated shift-solution creation from its assigned operations (UAT live write; Production gated)',
    requiredParams: [
      'environment',
      'route_id',
      'shifts_attempted',
      'shifts_created',
      'shifts_failed',
      'shifts_skipped',
      'timestamp',
    ],
    optionalParams: [],
  },
  fixed_route_overlap_run_started: {
    trigger: 'User starts a fixed-route overlap analysis run against the selected hosted network',
    requiredParams: ['feed_id', 'run_id', 'candidate_route_id', 'tolerance_meters', 'version', 'timestamp'],
    optionalParams: [],
  },
  fixed_route_overlap_run_completed: {
    trigger: 'A fixed-route overlap analysis run reaches the complete status',
    requiredParams: ['feed_id', 'run_id', 'candidate_route_id', 'result_count', 'version', 'timestamp'],
    optionalParams: ['top_overlap_pct', 'duration_ms'],
  },
  fixed_route_overlap_run_cancelled: {
    trigger: 'User cancels a fixed-route overlap analysis run',
    requiredParams: ['feed_id', 'run_id', 'candidate_route_id', 'version', 'timestamp'],
    optionalParams: [],
  },
  fixed_route_overlap_run_failed: {
    trigger: 'A fixed-route overlap analysis run fails',
    requiredParams: ['feature_area', 'error_category', 'feed_id', 'version', 'timestamp'],
    optionalParams: ['run_id', 'candidate_route_id', 'error_code', 'retryable'],
  },
  fixed_route_overlap_result_focused: {
    trigger: 'User selects an overlap result row to focus the hosted route on the map',
    requiredParams: ['feed_id', 'run_id', 'candidate_route_id', 'compared_route_id', 'version', 'timestamp'],
    optionalParams: [],
  },
  language_changed: {
    trigger: 'User picks a different language in the Profile settings panel',
    requiredParams: ['from', 'to', 'timestamp'],
    optionalParams: [],
  },
  spatial_analysis_run_started: {
    trigger: 'User chooses "Run Spatial Analysis" from the polygon context menu',
    requiredParams: ['polygon_id', 'vertex_count', 'has_source_layer', 'timestamp'],
    optionalParams: [],
  },
  spatial_analysis_run_completed: {
    trigger: 'A spatial analysis run reaches the complete status',
    requiredParams: ['run_id', 'layer_count', 'timestamp'],
    optionalParams: ['drt_candidate_count', 'duration_ms', 'census_source'],
  },
  spatial_analysis_run_cancelled: {
    trigger: 'User stops a spatial analysis run (or it is cancelled)',
    requiredParams: ['run_id', 'timestamp'],
    optionalParams: [],
  },
  spatial_analysis_run_failed: {
    trigger: 'A spatial analysis run fails',
    requiredParams: ['feature_area', 'error_category', 'timestamp'],
    optionalParams: ['error_code', 'retryable', 'run_id'],
  },
  spatial_analysis_report_expanded: {
    trigger: 'User expands a spatial analysis report into the modal (live run or saved report)',
    requiredParams: ['section_count', 'timestamp'],
    optionalParams: ['run_id', 'report_id', 'source'],
  },
};

export const FAILURE_EVENT_NAMES: ReadonlyArray<AnalyticsEventName> = [
  ANALYTICS_EVENT_NAMES.map_save_fail,
  ANALYTICS_EVENT_NAMES.simulation_run_fail,
  ANALYTICS_EVENT_NAMES.export_fail,
  ANALYTICS_EVENT_NAMES.operations_view_render_fail,
  ANALYTICS_EVENT_NAMES.wizard_helper_fail,
  ANALYTICS_EVENT_NAMES.postcode_assignment_failed,
  ANALYTICS_EVENT_NAMES.autopilot_jira_import_failed,
  ANALYTICS_EVENT_NAMES.fixed_route_overlap_run_failed,
  ANALYTICS_EVENT_NAMES.spatial_analysis_run_failed,
];

